import { cva } from 'class-variance-authority'

export const dialogStyles = cva(
  `
    rounded-xl
    p-6
  `,
  {
    variants: {
      color: {
        level0: 'bg-neutral-0 border border-neutral-200',
        level1: 'bg-neutral-100',
        priority: 'bg-orange-0',
        emphasis: 'bg-moss-0',
        brand: 'bg-moss-300 text-neutral-0',
        success: 'bg-green-0',
        warning: 'bg-yellow-0',
        danger: 'bg-red-0',
      },
    },
    defaultVariants: {
      color: 'level0',
    },
  }
)

export const dismissStyles = cva(
  `
    rounded-xl
    bg-dialog
    p-6
  `
)

export const overlayStyles = cva(
  `
    fixed
    inset-0
    z-50
    bg-black/80
    data-[state=open]:animate-in
    data-[state=closed]:animate-out
    data-[state=closed]:fade-out-0
    data-[state=open]:fade-in-0
  `
)

export const contentStyles = cva(
  `
    fixed
    left-[50%]
    top-[50%]
    z-50
    grid
    w-full
    max-w-lg
    translate-x-[-50%]
    translate-y-[-50%]
    gap-4
    border
    border-neutral-200
    rounded-xl
    p-6
    bg-neutral-0
    shadow-lg
    duration-200
    data-[state=open]:animate-in
    data-[state=closed]:animate-out
    data-[state=closed]:fade-out-0
    data-[state=open]:fade-in-0
    data-[state=closed]:zoom-out-95
    data-[state=open]:zoom-in-95
    data-[state=closed]:slide-out-to-left-1/2
    data-[state=closed]:slide-out-to-top-[48%]
    data-[state=open]:slide-in-from-left-1/2
    data-[state=open]:slide-in-from-top-[48%]
  `,
  {
    variants: {
      size: {
        sm: 'max-w-[440px]',
        md: 'max-w-[512px]',
        lg: 'max-w-[580px]',
      },
    },
    defaultVariants: {
      size: 'lg',
    },
  }
)

export const closeStyles = cva(
  `
    absolute
    right-0
    top-1
    rounded-sm
    opacity-70
    ring-offset-background
    transition-opacity
    hover:opacity-100
    focus:outline-none
    focus:ring-2
    focus:ring-ring
    focus:ring-offset-2
    disabled:pointer-events-none
    data-[state=open]:bg-accent
    data-[state=open]:text-muted-foreground
  `
)

export const footerStyles = cva(
  `
    flex
    flex-col-reverse
    sm:flex-row
    sm:justify-end
    sm:space-x-2
    gap-2
  `
)

export const titleStyles = cva(
  `
    text-lg
    font-semibold
    leading-none
    tracking-tight
  `,
  {
    variants: {
      center: {
        true: 'items-center justify-center',
      },
    },
    defaultVariants: {
      center: false,
    },
  }
)

export const descriptionStyles = cva(
  `
    text-sm
    text-muted-foreground
  `,
  {
    variants: {
      center: {
        true: 'items-center justify-center',
      },
    },
    defaultVariants: {
      center: false,
    },
  }
)
